import React from "react";
import { canWrite } from "../auth/perm";
import { CDN_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";

const cell = "px-3 py-2 text-sm border-b border-gray-200";
const th =
  "px-3 py-2 text-xs font-bold text-gray-600 border-b border-gray-300 bg-gray-50";

/**
 * props:
 * - items: Array<Organization>
 * - loading: boolean
 * - onEdit: (org) => void
 * - isRtl: boolean
 * - currentUser: object (برای پرمیژن)
 */
const OrganizationsTable = ({
  items = [],
  loading,
  onEdit,
  isRtl = true,
  currentUser,
}) => {
  const mayEdit = canWrite(currentUser, "organizations"); // expects "org:organizations:write"
  const navigate = useNavigate();

  if (loading) {
    return <p className="text-sm text-gray-500">در حال بارگذاری...</p>;
  }
  if (!items.length) {
    return <p className="text-sm text-gray-500">نتیجه‌ای یافت نشد.</p>;
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
      <table className={`min-w-full ${isRtl ? "text-right" : "text-left"}`}>
        <thead>
          <tr>
            <th className={th}>نام سازمان</th>
            <th className={th}>مالک</th>
            <th className={th}>تعداد اعضا</th>
            <th className={th}>تاریخ ایجاد</th>
            <th className={th}>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {items.map((org) => {
            const membersCount = org.members ?? 0;
            const ownerLabel =
              org.owner?.name ||
              org.owner?.email ||
              (typeof org.owner === "string" ? org.owner : "-");
            const createdAt = org.createdAt
              ? new Date(org.createdAt).toLocaleDateString("fa-IR")
              : "-";

            return (
              <tr key={org._id} className="hover:bg-gray-50">
                <td className={cell}>
                  <div className="flex items-center gap-2">
                    {org.logo ? (
                      <img
                        src={CDN_BASE_URL + org.logo}
                        alt={org.name}
                        className="w-12 h-12 rounded object-cover border"
                      />
                    ) : (
                      <span className="w-6 h-6 rounded bg-gray-100 border inline-block" />
                    )}
                    <span className="font-medium">{org.name || "-"}</span>
                  </div>
                </td>
                <td className={cell}>{ownerLabel || "-"}</td>
                <td className={cell}>{membersCount}</td>
                <td className={cell}>{createdAt}</td>
                <td className={cell}>
                  <button
                    onClick={() => onEdit(org)}
                    disabled={!mayEdit}
                    className={`px-3 py-1.5 text-sm rounded-md ${
                      mayEdit
                        ? "bg-purple-600 text-white hover:bg-purple-700"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    ویرایش
                  </button>
                  <button
                    onClick={() =>
                      navigate("/organization/organizations/" + org._id)
                    }
                    disabled={!mayEdit}
                    className={`px-3 py-1.5 text-sm rounded-md ${
                      mayEdit
                        ? "bg-indigo-600 text-white hover:bg-indigo-700 mx-1"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed mx-1"
                    }`}
                  >
                    اطلاعات بیشتر
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default OrganizationsTable;
